<template>
  <div class="no-data-container">
    <img class="no-data-icon" :src="icon | imagePath" alt />
    <span class="no-data-title">{{ title }}</span> 
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
    props: {
      icon: {
        //图片
        type: String,
        default: "icon_placeholder_normal.png",
        required: false
      },
      title: {
        //标题
        type: String,
        default: "暂无数据",
        required: false
      }
    }
  };
</script>
<style scoped>
  .no-data-container {
    width: 100%;
    /* height: 10rem; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
  }

  .no-data-icon {
    display: block;
    width: 150px;
    height: 129px;
  }

  .no-data-title {
    font-size: 16px;
    color: #999;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/assets/plugin/components/cm-placeholder/index.vue